(function(){
	function init(){
		document.querySelectorAll('[data-tartan-block]').forEach(function(block){
			if(block.dataset.lnInit) return;
			block.dataset.lnInit="1";
			var radios = block.querySelectorAll('.ln-tartan-radio');
			var nameEl = block.querySelector('[data-tartan-selected-name]');
			radios.forEach(function(r){
				r.addEventListener('change', function(){
					if(nameEl){ nameEl.textContent = this.dataset.displayName || this.value; }
				});
			});
		});
	}
	if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
	document.addEventListener('shopify:section:load',init);
})();